import { useCallback, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Layout } from 'antd'
import Navbar from '../../components/navbar'
import Sidebar from '../../components/Sidebar'
import './MainLayout.css'

const { Content } = Layout

export default function MainLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  const openMobileNav = useCallback(() => {
    setMobileNavOpen(true)
  }, [])

  const closeMobileNav = useCallback(() => {
    setMobileNavOpen(false)
  }, [])

  return (
    <Layout className="mainLayout__container">
      <Navbar onOpenMobileNav={openMobileNav} />
      <Layout className="mainLayout__body">
        <Sidebar
          mobileNavOpen={mobileNavOpen}
          onCloseMobileNav={closeMobileNav}
        />
        <Content className="mainLayout__content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}
